<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>创建限制规则</h4>
        </div>
        <div class="main-bd mg20">
            <el-row>
                <el-col :span="12">
                    <sub-form :model="loginRule" :scenario="'create'" @submit="submitForm($event)"></sub-form>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    import {LoginRuleService} from "~/services/LoginRule"
    import subForm from "~/views/login-rules/form.vue"
    export default {
        name: "create",
        components: {
            subForm
        },
        data() {
            return {
                loginRule: null
            };
        },
        created() {
            if (this.loginRule == null) {
                this.loginRule = LoginRuleService.getModel();
            }
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/login-rules/create.vue